// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchable-select {
  position: relative;
  width: 100%;
}

.searchable-select--picker .searchable-select__input {
  cursor: pointer;
  caret-color: transparent;
}

.searchable-select__input {
  width: 100%;
  padding-right: 2.25rem;
  /* Same look as create-report fields: plain input, no Bootstrap select chevron */
  background-image: none !important;
  background-color: #fff;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.searchable-select__input.custom-select {
  background: #fff none !important;
}

.searchable-select__clear {
  position: absolute;
  right: 0.35rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border: 0;
  background: transparent;
  color: #6c757d;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
  border-radius: 0.2rem;
}
.searchable-select__clear:hover {
  color: #343a40;
}

.searchable-select__dropdown {
  max-height: 14rem;
  overflow-y: auto;
  border: 1px solid rgba(0, 61, 122, 0.4);
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.searchable-select__dropdown--overlay {
  position: fixed;
  z-index: 1060;
  margin: 0;
  box-sizing: border-box;
}

.searchable-select__option {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 0;
  background: transparent;
  text-align: left;
  font-size: 0.875rem;
  color: #212529;
  cursor: pointer;
}
.searchable-select__option:hover, .searchable-select__option:focus {
  background: #f8f9fa;
  outline: none;
}
.searchable-select__option--disabled, .searchable-select__option:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.searchable-select__option--disabled:hover, .searchable-select__option--disabled:focus, .searchable-select__option:disabled:hover, .searchable-select__option:disabled:focus {
  background: transparent;
}

.searchable-select__option-label {
  font-weight: 600;
  color: var(--undp-jtf-btn-dark-color, #003d7a);
}

.searchable-select__empty {
  margin: 0;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: #6c757d;
}`, "",{"version":3,"sources":["webpack://./libs/features/ui/searchable-select/searchable-select.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;EACA,wBAAA;AACF;;AAEA;EACE,WAAA;EACA,sBAAA;EACA,gFAAA;EACA,iCAAA;EACA,sBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AACF;AACE;EACE,gCAAA;AACJ;;AAGA;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAAF;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,iBAAA;EACA,gBAAA;EACA,uCAAA;EACA,sBAAA;EACA,gBAAA;EACA,0CAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;AAGE;EAEE,mBAAA;EACA,aAAA;AAFJ;AAKE;EAEE,aAAA;EACA,mBAAA;AAJJ;AAMI;EAEE,uBAAA;AALN;;AAUA;EACE,gBAAA;EACA,8CAAA;AAPF;;AAUA;EACE,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAPF","sourcesContent":[".searchable-select {\n  position: relative;\n  width: 100%;\n}\n\n.searchable-select--picker .searchable-select__input {\n  cursor: pointer;\n  caret-color: transparent;\n}\n\n.searchable-select__input {\n  width: 100%;\n  padding-right: 2.25rem;\n  /* Same look as create-report fields: plain input, no Bootstrap select chevron */\n  background-image: none !important;\n  background-color: #fff;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  &.custom-select {\n    background: #fff none !important;\n  }\n}\n\n.searchable-select__clear {\n  position: absolute;\n  right: 0.35rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border: 0;\n  background: transparent;\n  color: #6c757d;\n  font-size: 1.25rem;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 0.2rem;\n\n  &:hover {\n    color: #343a40;\n  }\n}\n\n.searchable-select__dropdown {\n  max-height: 14rem;\n  overflow-y: auto;\n  border: 1px solid rgba(0, 61, 122, 0.4);\n  border-radius: 0.25rem;\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.searchable-select__dropdown--overlay {\n  position: fixed;\n  z-index: 1060;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.searchable-select__option {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  font-size: 0.875rem;\n  color: #212529;\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    background: #f8f9fa;\n    outline: none;\n  }\n\n  &--disabled,\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n\n    &:hover,\n    &:focus {\n      background: transparent;\n    }\n  }\n}\n\n.searchable-select__option-label {\n  font-weight: 600;\n  color: var(--undp-jtf-btn-dark-color, #003d7a);\n}\n\n.searchable-select__empty {\n  margin: 0;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
